// Chaves que existem em pt.js mas faltavam em es.js (mescladas em index.js).
export const esExtra = {
  "messagesList.metaWindowNotice": "Tienes 24h para responder después de recibir un mensaje, según las políticas de Meta.",
  "messagesList.header.buttons.integrationBlockedByBot": "La opción \"Desactivar chatbot\" de abajo está activada y silencia toda la automatización de este contacto, incluida esta integración.",
  "messagesList.header.buttons.integrationLabel": "Integración",
  "versionControl.title": "¡Hay una actualización disponible!",
  "versionControl.subtitle": "Haga clic en actualizar para obtener las últimas mejoras.",
  "versionControl.update": "Actualizar",
  "versionControl.updating": "Actualizando...",
  "backendErrors.ERR_CAMPAIGN_TEST_NUMBER": "Informe un número válido con código de país y de área para la prueba.",
  "backendErrors.ERR_CAMPAIGN_TEST_MESSAGE": "Escriba el mensaje 1 antes de probar.",
  "backendErrors.ERR_CAMPAIGN_TEST_OFICIAL": "La prueba rápida no está disponible en la conexión oficial. Guarde la campaña en una lista de prueba.",
  "backendErrors.ERR_CAMPAIGN_TEST_TEMPLATE": "Seleccione una plantilla aprobada antes de probar en la conexión oficial.",
  "backendErrors.ERR_COMPANY_MANAGED_BY_SUBSCRIPTION": "Esta empresa tiene una suscripción activa: plan, vencimiento y recurrencia los gestiona ella. Cancele la suscripción para editarlos.",
  "backendErrors.ERR_PASSWORD_RESET_INVALID_CODE": "Código inválido o expirado.",
  "backendErrors.ERR_PASSWORD_RESET_SESSION_EXPIRED": "La sesión de restablecimiento expiró. Comience de nuevo.",
  "backendErrors.ERR_PASSWORD_RESET_ALREADY_USED": "Esta solicitud de restablecimiento ya fue usada. Comience de nuevo.",
  "backendErrors.ERR_PASSWORD_RESET_INVALID_TOTP": "Código del autenticador inválido.",
  "backendErrors.ERR_PASSWORD_RESET_TOO_MANY_REQUESTS": "Demasiadas solicitudes. Espere un minuto e inténtelo de nuevo.",
  "backendErrors.ERR_PASSWORD_RESET_WEAK_PASSWORD": "La contraseña necesita al menos 5 caracteres.",
  "ticketInfo.copyPhone": "Copiar teléfono",
  "ticketInfo.quickMessages": "Respuestas rápidas",
  "ticketInfo.phonecopied": "¡Teléfono copiado al portapapeles!",
  "ticketInfo.noPhone": "No hay teléfono disponible para copiar",
  "ticketInfo.copyError": "Error al copiar el teléfono",
  "connections.transferTickets": "Transferir tickets",
  "connections.allOperational": "Todas las conexiones operando",
  "connections.needsAttention": "conexión necesita atención",
  "connections.needAttention": "conexiones necesitan atención",
  "connections.toolTips.oficialError.title": "Conexión no registrada en la API Oficial",
  "connections.toolTips.oficialError.content": "El registro en la API Oficial de WhatsApp no se completó. Elimine esta conexión y créela de nuevo; si el error persiste, verifique que el servicio de la API Oficial esté activo",
  "connections.table.channel": "Canal",
  "connections.table.color": "Color",
  "showTicketLogModal.loading": "Cargando…",
  "showTicketLogModal.summary": "{{events}} eventos · {{access}} accesos",
  "showTicketLogModal.empty": "Ningún evento registrado para este ticket.",
  "showTicketLogModal.showAccess": "Mostrar accesos",
  "showTicketLogModal.close": "Cerrar",
  "showTicketLogModal.kinds.transfered": "transferencias",
  "showTicketLogModal.kinds.pending": "devoluciones",
  "showTicketLogModal.kinds.closed": "cierres",
  "showTicketLogModal.kinds.reopen": "reaperturas",
  "contacts.toasts.blocked": "Contacto bloqueado.",
  "contacts.toasts.unblocked": "Contacto desbloqueado.",
  "contacts.confirm.blockTitle": "¿Bloquear a {{name}}?",
  "contacts.confirm.blockText": "El contacto no podrá enviar ni recibir mensajes hasta ser desbloqueado.",
  "contacts.confirm.block": "Bloquear",
  "contacts.confirm.unblockTitle": "¿Desbloquear a {{name}}?",
  "contacts.confirm.unblockText": "El contacto vuelve a enviar y recibir mensajes normalmente.",
  "contacts.confirm.unblock": "Desbloquear",
  "contacts.menu.importSection": "Importar",
  "contacts.menu.exportSection": "Exportar",
  "contacts.menu.importYourPhoneDesc": "Contactos guardados en el dispositivo conectado",
  "contacts.menu.importToExcelDesc": "Asigne columnas y aplique etiquetas",
  "contacts.menu.importChats": "De los chats existentes",
  "contacts.menu.importChatsDesc": "Crea contactos a partir de las conversaciones",
  "contacts.menu.exportSheet": "Exportar hoja de cálculo",
  "contacts.menu.exportSheetDesc": "Todos los {{count}} contactos · XLSX",
  "contacts.menu.deleteAll": "Eliminar todos los contactos",
  "contacts.bulk.selected": "{{count}} contactos seleccionados",
  "contacts.bulk.selectedAll": "Todos los {{count}} contactos seleccionados",
  "contacts.bulk.addTag": "Agregar etiqueta",
  "contacts.bulk.assignWallet": "Asignar cartera",
  "contacts.bulk.deleteSelected": "Eliminar seleccionados",
  "contacts.bulk.modeAdd": "Agregar a las etiquetas",
  "contacts.bulk.modeRemove": "Quitar de las etiquetas",
  "contacts.bulk.noTags": "Ninguna etiqueta registrada.",
  "contacts.bulk.tagsAdded": "Etiquetas aplicadas a {{count}} contacto(s).",
  "contacts.bulk.tagsRemoved": "Etiquetas quitadas de {{count}} contacto(s).",
  "contacts.bulk.walletUser": "Responsable",
  "contacts.bulk.walletNone": "Sin responsable (quitar cartera)",
  "contacts.bulk.walletQueue": "Cola",
  "contacts.bulk.walletQueueAuto": "Automática (una cola del agente)",
  "contacts.bulk.walletHint": "Reemplaza la cartera actual de los contactos seleccionados.",
  "contacts.bulk.walletAssigned": "Cartera asignada a {{count}} contacto(s).",
  "contacts.bulk.walletCleared": "Cartera quitada de {{count}} contacto(s).",
  "contacts.bulk.cancel": "Cancelar",
  "contacts.bulk.apply": "Aplicar",
  "contacts.pagination.showing": "Mostrando {{shown}} de {{total}}",
  "contacts.pagination.prev": "Página anterior",
  "contacts.pagination.next": "Página siguiente",
  "contacts.confirmDelete.oneTitle": "¿Eliminar a {{name}}?",
  "contacts.confirmDelete.manyTitle": "¿Eliminar {{count}} contactos?",
  "contacts.confirmDelete.allTitle": "¿Eliminar todos los {{count}} contactos?",
  "contacts.confirmDelete.text": "Los tickets y mensajes asociados se perderán. Esta acción no se puede deshacer.",
  "contacts.confirmDelete.confirm": "Eliminar",
  "contacts.exporting": "Generando hoja de cálculo…",
  "contacts.loading": "Cargando...",
  "contacts.loadMore": "Cargar más",
  "promptModal.form.agentName": "Nombre del agente",
  "promptModal.form.tone": "Tono de voz",
  "promptModal.form.toneFormal": "Formal",
  "promptModal.form.toneAmigavel": "Amigable",
  "promptModal.form.toneDescontraido": "Informal",
  "promptModal.form.toneTecnico": "Técnico",
  "promptModal.form.useEmojis": "Usar emojis",
  "promptModal.form.restrictions": "Restricciones del negocio",
  "promptModal.form.restrictionsHelp": "Reglas que la IA nunca puede romper (ej.: no hablar de precios)",
  "promptModal.form.transferInstructions": "Cuándo transferir a un humano",
  "promptModal.form.transferInstructionsHelp": "Situaciones en las que la IA debe pasar a un agente",
  "promptModal.form.transferMessage": "Mensaje de transferencia",
  "promptModal.form.knowledgeText": "Base de conocimiento (texto)",
  "promptModal.form.model": "Modelo",
  "promptModal.form.promptBase": "Prompt base",
  "promptModal.form.preview": "Vista previa del system prompt",
  "promptModal.tabs.personality": "Personalidad",
  "promptModal.tabs.knowledge": "Conocimiento",
  "promptModal.tabs.advanced": "Avanzado",
  "promptModal.files.title": "Archivos de conocimiento",
  "promptModal.files.saveFirst": "Guarde el agente para importar archivos.",
  "promptModal.files.upload": "Importar archivo",
  "promptModal.files.hint": "PDF, TXT o DOCX — hasta 20 MB por archivo, 20 archivos por agente.",
  "promptModal.files.processing": "Procesando",
  "promptModal.files.ready": "Listo",
  "promptModal.files.failed": "Falló",
  "promptModal.files.deleted": "Archivo eliminado.",
  "promptModal.files.uploaded": "Archivo enviado. El procesamiento continúa en segundo plano.",
  "prompts.table.knowledge": "Conocimiento",
  "prompts.table.knowledgeBadge": "Base de conocimiento",
  "contactModal.form.assignWallet": "Cartera de cliente",
  "contactModal.form.wallet": "Cartera",
  "contactModal.form.walletPlaceholder": "Sin responsable",
  "contactModal.form.walletQueue": "Cola de la cartera",
  "contactModal.form.walletQueuePlaceholder": "Seleccione la cola",
  "contactModal.form.birthDate": "Fecha de nacimiento",
  "contactModal.form.tags": "Etiquetas",
  "contactModal.form.tagsPlaceholder": "Agregar etiqueta…",
  "contactModal.form.extraEmpty": "Sin información adicional.",
  "contactModal.form.chatbotTitle": "Desactivar chatbot",
  "contactModal.form.chatbotOn": "El chatbot responde normalmente.",
  "contactModal.form.chatbotOff": "El chatbot no responde a este contacto.",
  "contactModal.form.campaignsTitle": "Acepta campañas",
  "contactModal.form.campaignsDesc": "Recibe envíos masivos",
  "contactModal.form.audioTitle": "Aceptar audios",
  "contactModal.form.audioDesc": "Permite recibir mensajes de voz de este contacto.",
  "contactModal.form.whatsapp": "Conexión de origen: ",
  "contactModal.buttons.addField": "Campo",
  "contactModal.buttons.block": "Bloquear",
  "contactModal.buttons.unblock": "Desbloquear",
  "contactModal.subtitleAdd": "Complete los datos para registrar un nuevo contacto",
  "contactModal.createdAt": "creado el",
  "contactModal.photoHint": "La foto viene del WhatsApp del contacto",
  "wallets.wallet": "Cartera",
  "queueModal.form.randomizeImmediate": "Aleatorizar automáticamente (inmediato)",
  "queueModal.form.typeRandomMode": "Tipo de rotación",
  "queueIntegrationModal.form.typebotKeywordRestart": "Palabra para reiniciar el flujo",
  "queueIntegrationModal.form.typebotRestartMessage": "Mensaje al reiniciar la conversación",
  "queueIntegrationModal.form.typebotDelayMessage": "Intervalo (ms) entre mensajes",
  "userModal.form.allowSeeMessagesInPendingTickets": "Permitir ver tickets pendientes",
  "userModal.form.showFlow": "Ver flujos",
  "userModal.form.allowRealTime": "Ver panel de atención",
  "userModal.form.allowConnections": "Permitir acciones en las conexiones",
  "userModal.form.showContacts": "Ver contactos",
  "userModal.form.showCampaign": "Ver campañas",
  "scheduleModal.buttons.addSchedule": "Agregar programación",
  "tagModal.subtitleAdd": "Etiqueta para contactos y tickets",
  "tagModal.usedIn": "Usada en {{contacts}} contactos y {{tickets}} tickets",
  "tagModal.previewEmpty": "Vista previa",
  "tagModal.nameShort": "El nombre debe tener al menos 3 caracteres.",
  "tagModal.fileTooBig": "El archivo {{name}} es demasiado grande. Máximo: 10MB.",
  "tagModal.fileType": "El tipo de archivo {{type}} no es compatible.",
  "tagModal.form.namePlaceholder": "Ej.: En negociación",
  "tagModal.form.preview": "Vista previa",
  "tagModal.form.customColor": "Color personalizado",
  "tagModal.form.kanbanTitle": "Usar como columna del Kanban",
  "tagModal.form.kanbanDesc": "Los tickets con esta etiqueta aparecen en su propia columna",
  "tagModal.form.onTimeout": "Al agotarse el tiempo",
  "tagModal.form.highlight": "Resaltar tarjeta",
  "tagModal.form.moveTo": "Mover a {{lane}}",
  "tagModal.form.none": "Ninguna",
  "tagModal.form.optional": "opcional",
  "tagModal.form.greetingPlaceholder": "¡Hola {nome}! Su propuesta está en análisis…",
  "tagModal.form.attach": "Adjuntar medio",
  "tagModal.form.recurrence": "Recurrencia",
  "tagModal.form.recurrenceDesc": "Volver a aplicar la etiqueta automáticamente después de un período",
  "tagModal.form.timeLane": "Alerta de tiempo en la columna",
  "tagModal.form.rollbackLaneId": "Volver a la columna (al retomar)",
  "tagModal.form.greetingMessageLane": "Mensaje al mover a esta columna",
  "tagModal.form.nextLaneId": "Columna de destino",
  "tagModal.form.mediaFiles": "Medios",
  "tagModal.buttons.delete": "Eliminar etiqueta",
  "tickets.messageHidden": "Mensaje oculto",
  "tickets.notification.messageHidden": "Mensaje oculto",
  "newTicketModal.subtitle": "Abre un nuevo ticket para el contacto",
  "newTicketModal.searchPlaceholder": "Escriba al menos 3 letras para buscar…",
  "newTicketModal.change": "Cambiar",
  "newTicketModal.queue": "Cola",
  "newTicketModal.connection": "Conexión",
  "newTicketModal.selectQueue": "Seleccione una cola",
  "newTicketModal.selectConnection": "Seleccione una conexión",
  "newTicketModal.assignTo": "Asignar a",
  "newTicketModal.me": "Mí",
  "newTicketModal.openTicket": "Ticket #{{id}} abierto",
  "newTicketModal.openBy": "Atendido por",
  "newTicketModal.greetingTitle": "Enviar saludo al abrir",
  "newTicketModal.greetingDesc": "Envía una respuesta rápida como primer mensaje",
  "newTicketModal.greetingUses": "Usa la respuesta rápida",
  "newTicketModal.greetingPick": "Elija la respuesta rápida…",
  "contactImport.title": "Importar contactos",
  "contactImport.step": "Paso {{n}} de {{total}}",
  "contactImport.dropTitle": "Arrastre la hoja de cálculo o haga clic para elegir",
  "contactImport.dropText": "XLSX, XLS o CSV · primera fila con el nombre de las columnas",
  "contactImport.invalidFile": "Archivo inválido. Use .xls, .xlsx o .csv.",
  "contactImport.fileMeta": "{{rows}} filas · {{cols}} columnas detectadas",
  "contactImport.changeFile": "Cambiar archivo",
  "contactImport.colSheet": "Columna de la hoja",
  "contactImport.colSample": "Ejemplo",
  "contactImport.colField": "Campo en Pulse",
  "contactImport.skipColumn": "Ignorar columna",
  "contactImport.updateTitle": "Actualizar existentes",
  "contactImport.updateDesc": "Mismo número: sobrescribe los datos",
  "contactImport.extraField": "Info extra",
  "contactImport.validateTitle": "Validar en WhatsApp",
  "contactImport.validateDesc": "Verifica el número antes de crear",
  "contactImport.applyTag": "Aplicar etiqueta",
  "contactImport.noTag": "Ninguna",
  "contactImport.missing": "Asigne los campos obligatorios: {{fields}}",
  "contactImport.invalidLines": "{{count}} fila(s) con número inválido serán ignoradas.",
  "contactImport.showLines": "Ver filas",
  "contactImport.hideLines": "Ocultar",
  "contactImport.downloadModel": "Descargar plantilla",
  "contactImport.cancel": "Cancelar",
  "contactImport.back": "Volver",
  "contactImport.importCount": "Importar {{count}} contactos",
  "contactImport.close": "Cerrar",
  "contactImport.startedTitle": "Importación en segundo plano",
  "contactImport.startedText": "{{count}} contactos fueron enviados y se están creando en segundo plano ({{ignored}} filas ignoradas). Recibirá una notificación al terminar; puede cerrar esta ventana.",
  "contactImport.progressTitle": "Importando contactos…",
  "contactImport.progressHint": "Puede cerrar esta ventana: la importación continúa y se le notificará al terminar.",
  "contactImport.counters": "{{criados}} nuevo(s) · {{ignorados}} ya existía(n) · {{invalidos}} inválido(s)",
  "contactImport.doneTitle": "Importación finalizada",
  "contactImport.doneText": "{{criados}} contacto(s) creado(s), {{ignorados}} ya existía(n), {{invalidos}} inválido(s). {{linhas}} fila(s) de la hoja quedaron fuera por falta de nombre o número.",
  "contactImport.cancelTitle": "Importación cancelada",
  "contactImport.errorTitle": "La importación falló",
  "smsModal.title": "Enviar SMS",
  "smsModal.subtitle": "Mensaje de texto por el proveedor de SMS",
  "smsModal.balance": "Saldo: {{saldo}}",
  "smsModal.balanceAfter": "Saldo tras el envío {{saldo}}",
  "smsModal.message": "Mensaje",
  "smsModal.placeholder": "Escriba el texto del SMS…",
  "smsModal.counter": "{{chars}} caracteres · {{sms}} SMS",
  "smsModal.hint": "Hasta 160 caracteres caben en 1 SMS; por encima, cada 153 caracteres cuentan uno más.",
  "smsModal.emptyBody": "Informe el texto del mensaje.",
  "smsModal.sent": "¡SMS enviado con éxito! {{fracoes}} fracción(es) debitada(s).",
  "smsModal.cancel": "Cancelar",
  "smsModal.send": "Enviar SMS",
  "contactImportPhone.title": "Importar de la agenda de WhatsApp",
  "contactImportPhone.subtitle": "Trae los contactos guardados en el dispositivo conectado",
  "contactImportPhone.titleChats": "Importar de los chats existentes",
  "contactImportPhone.subtitleChats": "Crea contactos a partir de las conversaciones de la conexión",
  "contactImportPhone.choose": "Elija la conexión",
  "contactImportPhone.empty": "Ninguna conexión WhatsApp QR Code registrada.",
  "contactImportPhone.connected": "Conectado",
  "contactImportPhone.offline": "La conexión debe estar conectada.",
  "contactImportPhone.startedChats": "Importación de los chats iniciada en segundo plano. Se le avisará al concluir.",
  "contactImportPhone.noDuplicates": "Los contactos ya registrados no se duplicarán.",
  "contactImportPhone.cancel": "Cancelar",
  "contactImportPhone.import": "Importar contactos",
  "contactImportPhone.started": "Importación de la agenda iniciada en segundo plano. Se le avisará al concluir.",
  "mainDrawer.listItems.callHistorical": "Historial de llamadas",
  "mainDrawer.listItems.birthdaySettings": "Cumpleaños",
  "mainDrawer.listItems.files": "Lista de archivos",
  "mainDrawer.listItems.reports": "Informes",
  "mainDrawer.listItems.management": "Gerencia",
  "messagesAPI.textMessage.connection": "Conexión",
  "messagesAPI.textMessage.connectionNone": "Seleccione una conexión…",
  "messagesAPI.textMessage.template": "Plantilla (usada fuera de la ventana de 24h)",
  "messagesAPI.textMessage.templateNone": "Ninguna — dejar que el sistema elija",
  "messagesAPI.textMessage.templateHelper": "Fuera de la ventana de 24h Meta solo acepta plantillas aprobadas. Elija cuál usar; dentro de la ventana, el mensaje va como texto libre.",
  "messagesAPI.textMessage.templateMediaBadge": "medio en el encabezado",
  "messagesAPI.textMessage.templateHeaderMediaUrl": "URL del medio del encabezado",
  "messagesAPI.textMessage.templateHeaderMediaUrlHelper": "Esta plantilla tiene un medio en el encabezado. Informe la URL pública del archivo (imagen, video o documento); Meta lo descarga de ese enlace al enviar.",
  "messagesAPI.textMessage.templateParamHelper": "Valor fijo o {nome}, {numero}, {email} (datos del contacto)",
  "notifications.messageHidden": "Mensaje oculto",
  "notifications.newMessage": "Nuevo mensaje de",
  "triggerFlowModal.title": "Disparar flujo",
  "triggerFlowModal.description": "Seleccione un flujo para ejecutar en este ticket. El ticket pasará al estado 'chatbot' durante la ejecución.",
  "triggerFlowModal.selectFlow": "Elija un flujo",
  "triggerFlowModal.selectedFlow": "Flujo seleccionado",
  "triggerFlowModal.flowId": "ID del flujo",
  "triggerFlowModal.noFlows": "Ningún flujo activo encontrado",
  "triggerFlowModal.cancel": "Cancelar",
  "triggerFlowModal.trigger": "Disparar flujo",
  "triggerFlowModal.triggering": "Disparando...",
  "triggerFlowModal.success": "¡Flujo disparado con éxito!",
  "triggerFlowModal.error": "Error al disparar el flujo",
  "quickMessages.selectMessage": "Seleccionar respuesta rápida",
  "quickMessages.hasMedia": "Con medios",
  "quickMessages.global": "Global",
  "quickMessages.noResultsFound": "Ninguna respuesta rápida encontrada para su búsqueda",
  "quickMessages.noQuickMessages": "Ninguna respuesta rápida disponible",
  "campaignReport.fetchError": "Error al buscar los datos del informe",
  "campaignReport.backButton": "Volver",
  "campaigns.dialog.form.pendingTicketStatus": "Pendiente",
  "compaies.table.generateInvoice": "Generar factura",
  "plans.form.public": "Público",
  "plans.form.trial": "Prueba",
  "plans.form.trialDays": "Días de prueba",
  "tags.subtitle": "Etiquetas de contactos y tickets · {{kanban}} usadas en el Kanban",
  "tags.empty": "Ninguna etiqueta encontrada",
  "tags.showing": "Mostrando {{shown}} de {{total}}",
  "tags.filters.all": "Todas",
  "tags.filters.kanban": "Kanban",
  "tags.filters.unused": "Sin uso",
  "tags.table.id": "ID",
  "tags.table.tag": "Etiqueta",
  "tags.table.type": "Tipo",
  "tags.table.recurrence": "Recurrencia",
  "tags.table.createdBy": "Creada por",
  "tags.table.kindKanban": "Kanban",
  "tags.table.kindContact": "Contacto",
  "tags.table.timeAlert": "Alerta de tiempo en el Kanban",
  "tags.table.seeContacts": "Ver contactos",
  "tags.table.edit": "Editar",
  "tags.table.delete": "Eliminar",
  "tags.buttons.deleteAll": "Eliminar todas",
  "tags.confirmDelete.titleBefore": "Eliminar la etiqueta",
  "tags.confirmDelete.textBefore": "Se quitará de",
  "tags.confirmDelete.contacts": "contactos",
  "tags.confirmDelete.and": "y",
  "tags.confirmDelete.tickets": "tickets",
  "tags.confirmDelete.textAfter": "Los contactos no se eliminan.",
  "tags.confirmDelete.kanbanWarn": "Esta etiqueta es una columna del Kanban — la columna se eliminará.",
  "tags.confirmDelete.confirm": "Eliminar etiqueta",
  "tags.confirmDeleteAll.title": "¿Eliminar todas las {{count}} etiquetas?",
  "tags.confirmDeleteAll.text": "Todas las etiquetas de la empresa se quitarán de contactos y tickets, incluidas las columnas del Kanban. Esta acción no se puede deshacer.",
  "tags.confirmDeleteAll.confirm": "Eliminar todas",
  "tags.toasts.deletedAll": "{{count}} etiqueta(s) eliminada(s).",
  "tagContacts.total": "{{count}} contactos",
  "tagContacts.filter": "Filtrar en esta lista…",
  "tagContacts.empty": "Ningún contacto con esta etiqueta.",
  "tagContacts.showing": "Mostrando {{shown}} de {{total}}",
  "tagContacts.seeAll": "Ver todos en Contactos →",
  "tagContacts.remove": "Quitar etiqueta",
  "tagContacts.removed": "Etiqueta quitada de {{name}}.",
  "settings.settings.options.copyContactPrefix": "Prefijo para copia de contactos",
  "settings.settings.options.copyContactPrefixPlaceholder": "Ej.: COPIA_",
  "messagesList.header.aiActive": "IA activa",
  "messagesList.header.amount": "Valor de prospección",
  "messagesList.header.buttons.pauseAI": "Pausar IA",
  "messagesList.header.buttons.resumeAI": "Reactivar IA",
  "messagesList.header.buttons.disableIntegration": "Desactivar integración",
  "messagesList.header.buttons.greetingAcceptedMessage": "Debe configurar un mensaje de saludo al aceptar el ticket.",
  "messageVariablesPicker.vars.scheduledDate": "Fecha de la programación",
  "messageInput.tooltip.triggerFlow": "Disparar flujo",
  "messageInput.type.template": "Plantilla Meta",
  "messagesAPIInstructions.fieldTemplateName": "\"templateName\": (opcional, conexión oficial) nombre de la plantilla usada fuera de la ventana de 24h",
  "messagesAPIInstructions.fieldTemplateParams": "\"templateParams\": (opcional) array de strings en el orden de las variables; acepta {nome}, {numero}, {email}",
  "messagesAPIInstructions.fieldTemplateHeaderMediaUrl": "\"templateHeaderMediaUrl\": (obligatorio si la plantilla tiene medio en el encabezado) URL http(s) pública del archivo",
  "messagesAPIInstructions.fieldTemplateOrderDetails": "\"templateOrderDetails\": (opcional, solo con templateName) objeto order_details de la plantilla de cobro Pix (ORDER_DETAILS): código copia y pega, valores en centavos ({ value, offset: 100 }); un error de formato responde 422 con la regla violada",
  "messagesAPIInstructions.fieldTemplateOrderDetailsExpiration": "\"order.expiration\": (opcional) timestamp epoch en segundos, mínimo 5 min en el futuro — vence el botón de la tarjeta; alinéelo con la validez real del Pix generado en el PSP, que no la controla",
  "messagesAPIInstructions.headerOrigin": "X-Origin (obligatorio): nombre del sistema que llama, hasta 80 caracteres (ej.: \"ERP Financiero\"). Aparece como origen en el informe de uso de la API en /reports/api",
  "messagesAPIInstructions.smsFieldNumber": "\"number\": \"5531999999999\" (obligatorio) — celular brasileño: 55 + código de área + número; lo que no sea dígito se elimina. El teléfono fijo (55 + código de área + 8 dígitos que empiezan por 2-5) se rechaza con 400, sin cargo",
  "messagesAPIInstructions.smsFieldBody": "\"body\": \"Tu boleta vence mañana. Paga en {link}\" (obligatorio) — el marcador {link} es opcional y recibe el enlace acortado",
  "messagesAPIInstructions.smsFieldLink": "\"link\": (opcional) objeto; exige {link} en el body y viceversa — informe url O whatsappNumber, nunca ambos",
  "messagesAPIInstructions.smsFieldLinkUrl": "\"link.url\": \"https://exemplo.com/boleto/123\" — URL http/https",
  "messagesAPIInstructions.smsFieldLinkWhatsapp": "\"link.whatsappNumber\": \"5531988887777\" — solo dígitos; abre una conversación en WhatsApp",
  "messagesAPIInstructions.smsFieldLinkPrefilled": "\"link.prefilledText\": \"Quiero pagar\" — (opcional) solo junto con whatsappNumber",
  "messagesAPIInstructions.smsResponseSend": "200: { \"id\": 123, \"status\": \"sent\", \"providerMessageId\": \"…\", \"parts\": 2, \"balance\": 998 } — balance puede venir null si falla la lectura del saldo; \"debitPending\": true solo si falla el débito posterior al envío. 400 { \"error\": \"…\" }: X-Origin ausente, campo inválido, número fijo (\"Número fixo não recebe SMS\") o no es celular, o saldo insuficiente",
  "messagesAPIInstructions.smsResponseStatus": "200: { \"id\", \"number\", \"status\": \"pending|sent|delivered|failed\", \"failureReason\", \"origin\", \"parts\", \"sentAt\", \"deliveredAt\" } — sin confirmación del proveedor tras 24 h (o el plazo configurado por la empresa), \"sent\" pasa a \"failed\" con failureReason \"Sem confirmação de entrega do provedor de SMS em 24h\"; si el proveedor confirma después, vuelve a \"delivered\". 404 { \"error\": \"SMS não encontrado.\" }",
  "messagesAPIInstructions.smsResponseBalance": "200: { \"balance\": 998 } — créditos = partes de SMS (hasta 160 caracteres = 1 parte; más que eso, 153 por parte)",
  "messagesAPIInstructions.responseText": "200 (conexión oficial): { \"message\": \"Mensagem enviada com sucesso\", \"companyId\": 1, \"ticketId\": 215, \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted\" } — accepted = aceptado por Meta; la entrega es asíncrona, consulta GET /api/messages/{messageId}/status. El texto de message no cambió y no garantiza la entrega. \"warning\" { code, category, reason, action, link, reasonOriginal } solo aparece si la conexión tiene un problema de cuenta. Conexión QR Code (Baileys): { \"message\": \"Mensagem enviada a fila de transmissão com sucesso\", \"companyId\", \"schedule\", \"filaId\" }, sin messageId (el mensaje nace después, por la cola). Si Meta lo rechaza al instante, vuelve un error HTTP (no 200) con el motivo traducido en \"error\". Tipos: messageId = número | null y wid = texto | null. null significa que el mensaje fue aceptado pero aún no tiene registro consultable: conserva el ticketId y no consultes el estado (consulta solo cuando messageId no sea null).",
  "messagesAPIInstructions.responseMedia": "200 (conexión oficial): { \"status\": \"SUCCESS\", \"messageId\": 4822, \"messageIds\": [4822], \"wid\": \"wamid.…\" } — SUCCESS es el contrato antiguo y solo indica aceptado por Meta; la entrega es asíncrona. messageId = primer archivo; messageIds = un id por archivo, en orden de envío; consulta cada uno en GET /api/messages/{messageId}/status. \"warning\" solo con problema de cuenta en la conexión. Conexión QR Code (Baileys): { \"status\": \"SUCCESS\" }, sin messageId. Tipos: messageId = número | null, messageIds = lista de número | null, wid = texto | null. null = aceptado, sin registro consultable: ignora los nulos y no consultes su estado.",
  "messagesAPIInstructions.statusResponse": "200: { \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted|sent|delivered|read|failed\", \"ack\": -1, \"failure\": { \"code\": 131042, \"category\": \"conta\", \"reason\": \"…\", \"action\": \"…\", \"link\": \"…\", \"reasonOriginal\": \"…\" } } — failure es null mientras el mensaje no haya fallado (ack: 0/1 enviada, 2 entregada, 3 leída, -1 = falló). Meta confirma la entrega después: el mensaje puede quedar un tiempo en accepted/sent. Nada se reenvía automáticamente. 404 { \"error\": \"ERR_NO_MESSAGE_FOUND\" }: id inexistente, de otra empresa o de otra conexión (el token solo ve los mensajes enviados por su propia conexión). 402 ERR_LICENSE_EXPIRED: licencia vencida",
  "whatsappModalRel.form.isOficial": "Informe de la atención",
  "whatsappModalRel.form.ticketId": "ID del ticket",
  "whatsappModalRel.form.client": "Cliente",
  "whatsappModalRel.form.number": "Número",
  "whatsappModalRel.form.agent": "Agente",
  "whatsappModalRel.form.date": "Fecha",
  "whatsappModalRel.form.lastMessage": "Último mensaje",
  "whatsappModalRel.form.fullReport": "El informe completo se adjuntó arriba",
  "whatsappModalRel.form.resolveAndTriggerIntegration": "Resolver y disparar integración",
  "whatsappModalRel.form.elementNotFoundForExport": "Elemento no encontrado para exportar.",
  "whatsappModalRel.form.reportFilename": "informe_atencion",
  "whatsappModal.form.maxUseInactiveTime": "Enviar flujo de inactividad x veces",
  "whatsappModal.form.timeToReturnQueue": "Tiempo para volver a la cola en minutos",
  "whatsappModal.form.timeAwaitActiveFlow": "Tiempo de espera para activar el flujo",
  "whatsappModal.form.flowInactiveTime": "Tiempo en minutos para enviar el flujo de inactividad",
  "whatsappModal.form.collectiveVacationEnd": "Fecha final",
  "whatsappModal.form.collectiveVacationStart": "Fecha inicial",
  "whatsappModal.form.collectiveVacationMessage": "Mensaje de vacaciones colectivas",
  "whatsappModal.form.queueIdImportMessages": "Cola para importar los mensajes",
  "whatsappModal.form.isOficial": "Oficial",
  "whatsappModal.form.phone_number_id": "ID del número de teléfono",
  "whatsappModal.form.waba_id": "Waba ID",
  "whatsappModal.form.send_token": "Token de envío",
  "whatsappModal.form.business_id": "ID del negocio",
  "whatsappModal.form.phone_number": "Número de teléfono",
  "whatsappModal.errorRatingMessage": "Es obligatorio informar un mensaje de evaluación cuando se usa el NPS.",
  "chatMessages.deletedAdminShort": "Visible para admin",
  "chatMessages.copy": "Copiar",
  "chatMessages.copied": "Mensaje copiado.",
  "chatMessages.react": "Reaccionar",
  "chatMessages.linkTicket": "Vincular ticket",
  "chatMessages.ticketNumber": "N.º del ticket",
  "chatMessages.ticketNotFound": "Ticket no encontrado.",
  "chatMessages.attachTicket": "Adjuntar al mensaje",
  "chatMessages.openTicket": "Abrir atención",
  "chatMessages.editTimeLeft": "Quedan {{min}} min para editar",
  "chatMessages.editHint": "El mensaje quedará marcado como \"editado\" para todos.",
  "chatMessages.editedLabel": "editado",
  "chatMessages.forwardedLabel": "Reenviado",
  "chatMessages.forwardSubtitle": "Elija una o más conversaciones",
  "chatMessages.forwardedTo": "Reenviado a {{count}} conversación(es).",
  "chatMessages.selectedCount": "{{count}} seleccionada(s)",
  "chatMessages.deleteTitle": "¿Eliminar mensaje?",
  "chatMessages.deleteText": "Se reemplazará por \"Este mensaje fue eliminado\" para todos. Los administradores aún pueden ver el contenido original.",
  "chatMessages.deleteConfirm": "Eliminar",
  "chatMessages.message": "Mensaje",
  "chatMessages.document": "Documento",
  "chatMessages.readyToSend": "listo para enviar",
  "chatMessages.placeholderGroup": "Mensaje para el grupo…",
  "chatMessages.placeholderDm": "Mensaje…",
  "chatPopover.deleteMessage": "¿Seguro que desea eliminar este mensaje?",
  "chatIndex.markAllRead": "Marcar todo como leído",
  "chatIndex.filters.all": "Todas",
  "chatIndex.filters.unread": "No leídas",
  "chatIndex.filters.groups": "Grupos",
  "chatIndex.selectChat": "Elija una conversación o cree una nueva",
  "chatIndex.participants": "{{count}} participantes",
  "chatIndex.online": "{{count}} en línea",
  "chatIndex.onlineNow": "En línea",
  "chatIndex.offline": "Desconectado",
  "chatIndex.searchInChat": "Buscar en la conversación",
  "chatIndex.searchInChatPlaceholder": "Buscar en los mensajes cargados…",
  "chatIndex.menu.section": "Conversación",
  "chatIndex.menu.details": "Detalles del grupo",
  "chatIndex.menu.detailsDm": "Detalles de la conversación",
  "chatIndex.menu.edit": "Editar grupo",
  "chatIndex.menu.mute": "Silenciar",
  "chatIndex.menu.unmute": "Reactivar notificaciones",
  "chatIndex.menu.markRead": "Marcar como leído",
  "chatIndex.menu.leave": "Salir del grupo",
  "chatIndex.menu.delete": "Eliminar conversación",
  "chatIndex.info.createdBy": "Creado por {{name}}",
  "chatIndex.info.members": "Participantes · {{count}}",
  "chatIndex.info.add": "Agregar",
  "chatIndex.deleteChat.title": "¿Eliminar esta conversación?",
  "chatIndex.deleteChat.groupBefore": "El grupo",
  "chatIndex.deleteChat.dmBefore": "La conversación con",
  "chatIndex.deleteChat.middle": "y sus",
  "chatIndex.deleteChat.messages": "{{count}} mensajes",
  "chatIndex.deleteChat.after": "se eliminarán para todos los {{count}} participantes.",
  "chatIndex.deleteChat.confirm": "Eliminar para todos",
  "chatIndex.leave.title": "¿Salir de {{name}}?",
  "chatIndex.leave.text": "Dejará de recibir los mensajes de este grupo. Un administrador puede agregarlo de nuevo.",
  "chatIndex.leave.confirm": "Salir del grupo",
  "chatIndex.toasts.chatDeleted": "Conversación eliminada.",
  "chatIndex.toasts.left": "Salió del grupo.",
  "chatIndex.toasts.muted": "Conversación silenciada.",
  "chatIndex.toasts.unmuted": "Notificaciones reactivadas.",
  "chatIndex.toasts.mentioned": "{{name}} lo mencionó en {{chat}}. Haga clic para abrir.",
  "chatIndex.modal.subtitle": "Converse con un colega o cree un grupo del equipo",
  "chatIndex.modal.subtitleDirect": "Elija un colega para conversar",
  "chatIndex.modal.editSubtitle": "Nombre y participantes del grupo",
  "chatIndex.modal.direct": "Directa",
  "chatIndex.modal.group": "Grupo",
  "chatIndex.modal.namePlaceholder": "Ej.: Soporte N1 — turno de la tarde",
  "chatIndex.modal.nameRequired": "Informe el nombre del grupo.",
  "chatIndex.modal.membersRequired": "Elija al menos un participante.",
  "chatIndex.modal.members": "Participantes",
  "chatIndex.modal.selected": "{{count}} seleccionados",
  "chatIndex.modal.addQueue": "Agregar toda la cola {{queue}}",
  "chatIndex.modal.searchPerson": "Buscar persona…",
  "chatIndex.modal.onlineSection": "En línea",
  "chatIndex.modal.offlineSection": "Desconectados",
  "chatIndex.modal.existing": "Conversación existente",
  "chatIndex.modal.directHint": "Si ya existe una conversación con la persona, se abrirá.",
  "twoFactor.setup.title": "Autenticación de dos factores (2FA)",
  "twoFactor.setup.description": "Agregue una capa extra de seguridad a su cuenta usando una aplicación de autenticación como Google Authenticator o Authy.",
  "twoFactor.setup.enable": "Activar 2FA",
  "twoFactor.setup.manage": "Gestionar 2FA",
  "twoFactor.setup.statusEnabled": "La autenticación de dos factores está activada en su cuenta.",
  "twoFactor.setup.statusDisabled": "La autenticación de dos factores no está activada.",
  "twoFactor.setup.activate": "Activar",
  "twoFactor.setup.deactivate": "Desactivar 2FA",
  "twoFactor.setup.adminDeactivate": "Desactivar 2FA (Admin)",
  "twoFactor.setup.passwordConfirm": "Confirme su contraseña",
  "twoFactor.setup.scanQR": "Escanee el código QR de abajo con su aplicación de autenticación:",
  "twoFactor.setup.manualEntry": "O ingrese el código manualmente:",
  "twoFactor.setup.verifyCode": "Código de verificación",
  "twoFactor.setup.verifyAndActivate": "Verificar y activar",
  "twoFactor.setup.invalidCode": "Código inválido. Ingrese los 6 dígitos de su app.",
  "twoFactor.setup.recoveryTitle": "Códigos de recuperación",
  "twoFactor.setup.recoveryWarning": "Guarde estos códigos en un lugar seguro. Cada código solo puede usarse una vez. Estos códigos no se mostrarán de nuevo.",
  "twoFactor.setup.copyCodes": "Copiar códigos",
  "twoFactor.setup.codesCopied": "¡Códigos copiados!",
  "twoFactor.setup.confirmSaved": "Confirmo que guardé los códigos de recuperación",
  "twoFactor.setup.done": "Concluir",
  "twoFactor.setup.close": "Cerrar",
  "twoFactor.setup.disabled": "2FA desactivado con éxito",
  "twoFactor.setup.mandatoryMessage": "Su organización exige autenticación de dos factores. Configúrela ahora para continuar.",
  "twoFactor.setup.setupComplete": "¡2FA configurado con éxito! Será redirigido automáticamente.",
  "twoFactor.policy.label": "Política de 2FA",
  "twoFactor.policy.optional": "Opcional",
  "twoFactor.policy.mandatory": "Obligatorio",
  "twoFactor.policy.disabled": "Desactivado",
  "signup.toasts.disabled": "El registro de usuarios está desactivado por el momento. Inténtelo de nuevo más tarde.",
  "dashboard.cards.activeTickets": "Tickets activos",
  "dashboard.cards.passiveTickets": "Tickets pasivos",
  "dashboard.cards.groups": "Grupos",
  "reports.searchPlaceholder": "Buscar...",
  "fileModal.form.fileOptions": "Lista de archivos",
  "ticketsManager.buttons.resolveAll": "Resolver todos",
  "ticketsList.buttons.kanbanActions": "Opciones de Kanban",
  "languages.pt-BR": "Portugués",
  "scheduleModal.failure.title": "Falló el último envío",
  "scheduleModal.failure.unknown": "El envío falló, pero no se registró el motivo.",
  "schedules.failureTooltip": "Motivo: {{reason}}",
  "scheduleModal.template.subtitle": "Elija la plantilla que Meta entregará en el horario programado",
  "scheduleModal.template.title": "Plantilla aprobada (WhatsApp Oficial)",
  "scheduleModal.template.select": "Elegir plantilla",
  "scheduleModal.template.placeholder": "Ninguna plantilla seleccionada",
  "scheduleModal.template.none": "Sin plantilla",
  "scheduleModal.template.paramLabel": "Valor de {{token}}",
  "scheduleModal.template.paramHelper": "Texto fijo o {nome}, {numero}, {email} - resueltos con el contacto al enviar",
  "scheduleModal.template.preview": "Vista previa",
  "scheduleModal.template.incomplete": "Complete todas las variables de la plantilla.",
  "scheduleModal.template.windowHint": "Sin plantilla, el envío solo funciona si el contacto escribió en las últimas 24 horas. Fuera de esa ventana Meta exige una plantilla aprobada.",
  "scheduleModal.template.emptySync": "Ninguna plantilla aprobada en esta conexión. Sincronice las plantillas en la pantalla de Conexiones.",
  "scheduleModal.template.emptyIneligible": "Esta conexión tiene {{count}} plantilla(s) aprobada(s), pero ninguna sirve aquí: todas exigen medios en el encabezado o botón con URL variable.",
  "scheduleModal.template.mixed": "Esta plantilla mezcla variables numeradas y con nombre en el mismo cuerpo. Corríjala en Meta y sincronice de nuevo.",
  "plans.form.amountYearly": "Valor anual",
  "plans.grid.perMonth": "/mes",
  "plans.grid.perYear": "/año",
  "settings.settings.payments.mpPublicKey": "Mercado Pago · Public Key",
  "settings.settings.payments.pixDiscount": "Descuento en Pix (%)",
  "settings.settings.options.updateSuccess": "Operación actualizada con éxito.",
  "subscription.checkout.titleNew": "Contratar plan",
  "subscription.checkout.titleInvoice": "Pagar factura",
  "subscription.checkout.subtitleNew": "{{plan}} · el ciclo comienza hoy, {{date}}",
  "subscription.checkout.subtitleInvoice": "Factura del {{date}} · {{value}}",
  "subscription.checkout.stepPlan": "Plan",
  "subscription.checkout.stepPayment": "Pago",
  "subscription.checkout.period": "Periodicidad",
  "subscription.checkout.invoicePeriod": "Período de la factura",
  "subscription.checkout.monthly": "Mensual",
  "subscription.checkout.yearly": "Anual",
  "subscription.checkout.perMonth": "/mes",
  "subscription.checkout.perYear": "/año",
  "subscription.checkout.chargedOnDay": "Se cobra todos los días {{day}}",
  "subscription.checkout.approxMonthly": "≈ {{value}} por mes",
  "subscription.checkout.saveOneMonth": "Ahorre 1 mes",
  "subscription.checkout.saveMonths": "Ahorre {{count}} meses",
  "subscription.checkout.planSummary": "Resumen del plan",
  "subscription.checkout.selected": "Seleccionado",
  "subscription.checkout.users": "Usuarios",
  "subscription.checkout.connections": "Conexiones",
  "subscription.checkout.queues": "Colas",
  "subscription.checkout.lineMonthly": "{{plan}} · mensual",
  "subscription.checkout.lineYearly": "{{plan}} · anual",
  "subscription.checkout.installmentsRow": "Cuotas con tarjeta",
  "subscription.checkout.installmentsUpTo": "hasta {{label}}",
  "subscription.checkout.installmentLabel": "{{n}}x de {{value}}",
  "subscription.checkout.pixDiscountRow": "Descuento Pix ({{percent}}%)",
  "subscription.checkout.total": "Total del ciclo",
  "subscription.checkout.totalInvoice": "Total de la factura",
  "subscription.checkout.cycleCardMonthly": "Se renueva automáticamente el {{date}} con la misma tarjeta",
  "subscription.checkout.cycleCardYearly": "Válido hasta el {{date}}. Le avisamos 5 días antes de la renovación.",
  "subscription.checkout.cyclePix": "Próxima factura el {{date}}. Con Pix la renovación no es automática: le avisamos 5 días antes.",
  "subscription.checkout.tabsLabel": "Forma de pago",
  "subscription.checkout.tabCard": "Tarjeta",
  "subscription.checkout.tabPix": "Pix",
  "subscription.checkout.secure": "Los datos de la tarjeta van directo a Mercado Pago. Pulse no almacena el número.",
  "subscription.checkout.subscribe": "Suscribirse · {{value}}",
  "subscription.checkout.payInvoice": "Pagar · {{value}}",
  "subscription.checkout.generatePix": "Generar Pix · {{value}}",
  "subscription.checkout.terms": "Al suscribirse acepta la renovación automática en cada ciclo. Cancele cuando quiera en Suscripción › Plan actual.",
  "subscription.checkout.pixHint": "Genere el código y pague en la app de su banco. La confirmación llega en segundos.",
  "subscription.checkout.qrAlt": "Código QR de Pix",
  "subscription.checkout.waitingPix": "Esperando el pago. La pantalla se actualiza sola cuando se confirme el Pix.",
  "subscription.checkout.waitingCard": "Pago en análisis por Mercado Pago. La pantalla se actualiza sola cuando se confirme.",
  "subscription.checkout.waitingRecurring": "Esperando la confirmación de Mercado Pago. La suscripción se activa sola en unos instantes.",
  "subscription.checkout.alreadyPaidQuestion": "¿Pagó y nada cambió en 2 minutos?",
  "subscription.checkout.alreadyPaid": "Ya pagué",
  "subscription.card.actions.checkPayment": "Ya pagué · verificar pago",
  "auth.dueDate.expired": "Su suscripción venció el {{date}}. Regularice el pago para volver a usar el sistema.",
  "subscription.checkout.stillPending": "Aún no recibimos la confirmación. Espere unos instantes más.",
  "subscription.checkout.paid": "Pago confirmado. ¡Su suscripción está activa!",
  "subscription.checkout.cardRejected": "Tarjeta rechazada. Revise los datos o use otra tarjeta.",
  "subscription.checkout.cardUnavailable": "El pago con tarjeta no está disponible en este momento. Use Pix.",
  "subscription.checkout.cardLoadError": "No fue posible cargar el formulario de la tarjeta. Use Pix o intente de nuevo.",
  "subscription.checkout.loadError": "No fue posible cargar el checkout.",
  "subscription.checkout.retry": "Intentar de nuevo",
  "subscription.checkout.noPrice": "Este plan aún no tiene precio configurado. Hable con soporte.",
  "subscription.checkout.pageTitle": "Suscripción",
  "subscription.checkout.licenseLabel": "Período de licencia",
  "subscription.checkout.licenseDueToday": "¡Su licencia vence hoy!",
  "subscription.checkout.licenseDueIn": "Su licencia vence en {{days}} días.",
  "subscription.checkout.licenseExpired": "Su licencia está vencida. Regularice para volver a usar el sistema.",
  "subscription.checkout.billingEmail": "Correo de cobro",
  "subscription.checkout.adminOnlyNotice": "El acceso está suspendido hasta el pago de la suscripción. Pida al administrador de la empresa que lo regularice en Suscripción.",
  "subscription.page.title": "Mi suscripción",
  "subscription.page.smsBalance": "Saldo de créditos SMS:",
  "subscription.checkout.subscribeNow": "Suscribirse ahora",
  "backendErrors.ERR_SUB_ALREADY_ACTIVE": "Su empresa ya tiene una suscripción activa.",
  "backendErrors.ERR_SUB_PENDING_IN_PROGRESS": "Ya hay una contratación en curso. Espere unos instantes e intente de nuevo.",
  "backendErrors.ERR_SUB_INVOICE_JUST_PAID": "Esta factura acaba de pagarse. Actualice la página.",
  "backendErrors.ERR_SUB_CARD_REJECTED": "Tarjeta rechazada. Revise los datos o use otra tarjeta.",
  "backendErrors.ERR_SUB_INVALID_COMBINATION": "Esta combinación de período y forma de pago no está disponible para el plan.",
  "backendErrors.ERR_SUB_INVALID_PERIOD": "Período inválido para este plan.",
  "backendErrors.ERR_SUB_CARD_TOKEN_REQUIRED": "Complete los datos de la tarjeta.",
  "backendErrors.ERR_SUB_PAYMENT_METHOD_REQUIRED": "No identificamos la marca de la tarjeta. Revise el número.",
  "backendErrors.ERR_SUB_ALREADY_RECURRING": "Esta suscripción ya tiene cobro automático con tarjeta. Espere el próximo intento o pague con Pix.",
  "backendErrors.ERR_SUB_PREVIOUS_PREAPPROVAL": "No fue posible cerrar el intento anterior en Mercado Pago. Intente de nuevo en instantes.",
  "backendErrors.ERR_SUB_NOT_FOUND": "Suscripción no encontrada.",
  "backendErrors.ERR_SUB_NO_CARD": "Esta suscripción no tiene tarjeta registrada.",
  "backendErrors.ERR_SUB_NO_RECURRING": "Esta suscripción no tiene cobro automático con tarjeta.",
  "backendErrors.ERR_SUB_SAME_PERIOD": "La suscripción ya está en ese período.",
  "backendErrors.ERR_SUB_SAME_PLAN": "La suscripción ya está en ese plan.",
  "backendErrors.ERR_SUB_UPGRADE_PENDING": "Hay un upgrade esperando pago. Pague su factura antes de otro cambio.",
  "backendErrors.ERR_SUB_NEXT_CYCLE_INVOICE_OPEN": "La factura del próximo ciclo ya fue emitida. Páguela antes de cambiar la suscripción.",
  "backendErrors.ERR_SUB_INVALID_ACTION": "Acción inválida para la suscripción.",
  "backendErrors.ERR_INVOICE_NOT_FOUND": "Factura no encontrada.",
  "backendErrors.ERR_INVOICE_NOT_OPEN": "Esta factura ya no está pendiente.",
  "backendErrors.ERR_NO_PLAN_FOUND": "Su empresa no tiene un plan definido. Hable con soporte.",
  "subscription.card.title": "Plan actual",
  "subscription.card.status.active": "Activa",
  "subscription.card.status.pastDue": "Atrasada",
  "subscription.card.status.canceled": "Cancelada, acceso hasta {{date}}",
  "subscription.card.status.pending": "Esperando pago",
  "subscription.card.renewal.auto": "Automática",
  "subscription.card.renewal.pix": "Manual (Pix)",
  "subscription.card.renewal.savedCard": "En la tarjeta, con aviso 5 días antes",
  "subscription.card.renewal.none": "No se renueva",
  "subscription.card.methodPix": "Pix",
  "subscription.card.methodRecurring": "tarjeta recurrente",
  "subscription.card.methodInstallments": "{{n}} cuotas en tarjeta",
  "subscription.card.methodCardOnce": "tarjeta, pago único",
  "subscription.card.plan": "Plan",
  "subscription.card.periodicity": "Periodicidad",
  "subscription.card.cycle": "Ciclo actual",
  "subscription.card.nextCharge": "Próximo cobro",
  "subscription.card.paymentMethod": "Medio de pago",
  "subscription.card.renewal.label": "Renovación",
  "subscription.card.accessUntil": "Acceso hasta",
  "subscription.card.cycleRange": "{{start}} → {{end}}",
  "subscription.card.nextChargeValue": "{{date}} · {{value}}",
  "subscription.card.cardMasked": "{{brand}} •••• {{last4}}",
  "subscription.card.cardOnFile": "Tarjeta",
  "subscription.card.pendingPlan": "Cambia a {{plan}} el {{date}}",
  "subscription.card.pendingPeriod": "Cambia a {{period}} el {{date}}",
  "subscription.card.actions.changePlan": "Cambiar de plan",
  "subscription.card.actions.toMonthly": "Cambiar a mensual",
  "subscription.card.actions.toYearly": "Cambiar a anual",
  "subscription.card.actions.changeCard": "Cambiar tarjeta",
  "subscription.card.actions.cancel": "Cancelar suscripción",
  "subscription.card.actions.payInvoice": "Pagar factura · {{value}}",
  "subscription.card.actions.subscribe": "Contratar plan",
  "subscription.card.rulesNote": "Los cambios de periodicidad y los downgrades valen en el próximo ciclo. El upgrade cobra solo la diferencia de los días restantes y vale en cuanto se pague. Al cancelar, el acceso sigue hasta el {{date}}.",
  "subscription.card.canceledNote": "Suscripción cancelada. El acceso sigue hasta el {{date}} y no se cobrará nada más.",
  "subscription.card.pendingNote": "Esperando la confirmación del pago de la contratación.",
  "subscription.card.pastDueNote": "La renovación no se pagó. Pague la factura para no perder el acceso.",
  "subscription.card.upgradePendingNote": "Upgrade esperando pago ({{value}}). El nuevo plan vale en cuanto se pague.",
  "subscription.card.empty": "Su empresa aún no tiene suscripción. Contrate un plan con tarjeta o Pix.",
  "subscription.card.loadError": "No se pudo cargar la suscripción.",
  "subscription.card.renewalFailed": "No pudimos cobrar la renovación de la suscripción. Pague la factura en Suscripción para no perder el acceso.",
  "subscription.manage.cancelTitle": "Cancelar suscripción",
  "subscription.manage.cancelBody": "La suscripción no se renovará. Sigue usando el sistema normalmente hasta el {{date}}; después, el acceso se suspende.",
  "subscription.manage.cancelInvoices": "Las facturas pendientes de esta suscripción también se cancelan.",
  "subscription.manage.cancelConfirm": "Cancelar suscripción",
  "subscription.manage.cancelKeep": "Mantener suscripción",
  "subscription.manage.canceled": "Suscripción cancelada. El acceso sigue hasta el {{date}}.",
  "subscription.manage.periodTitle": "Cambiar periodicidad",
  "subscription.manage.periodSubtitle": "{{plan}} · vale desde el próximo ciclo",
  "subscription.manage.periodNoticePix": "Vale en el próximo ciclo, desde el {{date}}. La próxima factura Pix ya viene en el nuevo período.",
  "subscription.manage.periodNoticeCardYearly": "Vale en el próximo ciclo, desde el {{date}}. El primer cobro anual se hará en el checkout (tarjeta o Pix).",
  "subscription.manage.periodNoticeCardMonthly": "Vale en el próximo ciclo, desde el {{date}}. El primer cobro mensual se hará en el checkout (tarjeta o Pix).",
  "subscription.manage.periodUndo": "El cambio programado se deshace y la suscripción sigue como está.",
  "subscription.manage.periodConfirm": "Confirmar cambio",
  "subscription.manage.periodChanged": "Cambio de periodicidad programado para el {{date}}.",
  "subscription.manage.periodUndone": "Cambio de periodicidad deshecho.",
  "subscription.manage.cardTitle": "Cambiar tarjeta",
  "subscription.manage.cardSubtitle": "No se cobra nada ahora",
  "subscription.manage.cardNotice": "La nueva tarjeta se usa en los próximos cobros. El valor del formulario es solo el del ciclo actual, para validar la tarjeta: no se cobra nada ahora.",
  "subscription.manage.cardSubmit": "Guardar tarjeta",
  "subscription.manage.cardChanged": "Tarjeta actualizada.",
  "subscription.manage.planTitle": "Cambiar de plan",
  "subscription.manage.planSubtitle": "Precios en el período actual ({{period}})",
  "subscription.manage.planListLabel": "Planes disponibles",
  "subscription.manage.planCurrent": "Actual",
  "subscription.manage.planScheduled": "Programado",
  "subscription.manage.planLimits": "{{users}} usuarios · {{connections}} conexiones · {{queues}} colas",
  "subscription.manage.planUpgrade": "Upgrade: cobramos ahora solo la diferencia proporcional a los días que faltan del ciclo. El nuevo plan vale en cuanto se confirme el pago.",
  "subscription.manage.planUpgradeCard": "Se cobra en la tarjeta {{card}}.",
  "subscription.manage.planUpgradePix": "Generaremos un Pix por la diferencia.",
  "subscription.manage.planDowngrade": "Downgrade: vale desde el próximo ciclo, el {{date}}. Hasta entonces sigue en el plan actual.",
  "subscription.manage.planUndo": "El downgrade programado se deshace; sigue en el plan actual.",
  "subscription.manage.planConfirm": "Confirmar cambio",
  "subscription.manage.planNoOthers": "No hay otros planes disponibles en este período.",
  "subscription.manage.planDowngradeScheduled": "Downgrade programado para el {{date}}.",
  "subscription.manage.planUndone": "Downgrade deshecho.",
  "subscription.manage.planChanged": "Plan cambiado.",
  "subscription.manage.planUpgradePaid": "Upgrade pagado. El nuevo plan ya está vigente.",
  "subscription.manage.planUpgradeReview": "Pago del upgrade en análisis. El plan cambia en cuanto se apruebe.",
  "subscription.manage.planUpgradeOpen": "No pudimos cobrar el upgrade en la tarjeta. Pague la factura del upgrade en la lista de facturas.",
  "subscription.manage.planPixTitle": "Pague el upgrade con Pix",
  "subscription.manage.planPixValue": "Diferencia proporcional: {{value}}",
  "subscription.manage.close": "Cerrar",
  "invoices.status.paid": "Pagada",
  "invoices.status.overdue": "Vencida",
  "invoices.status.open": "Pendiente",
  "invoices.status.canceled": "Cancelada",
  "invoices.table.period": "Período",
  "invoices.table.method": "Medio",
  "invoices.table.pay": "Pagar",
  "subscription.manage.cardUnavailable": "El cambio de tarjeta no está disponible ahora. Intente de nuevo más tarde.",
  "invoices.table.status": "Estado",
  "metaErrors.notDelivered": "No entregado",
  "metaErrors.generic": "WhatsApp rechazó el envío de este mensaje",
  "metaErrors.showDetails": "Ver detalles",
  "metaErrors.hideDetails": "Ocultar detalles",
  "metaErrors.technicalCode": "Código técnico",
  "metaErrors.markResolved": "Ya lo regularicé",
  "metaErrors.markResolvedTitle": "¿Marcar el problema como regularizado?",
  "metaErrors.markResolvedBody": "El aviso de problema en la cuenta desaparece de esta conexión. Si Meta vuelve a rechazar envíos, reaparece solo.",
  "metaErrors.markResolvedConfirm": "Sí, ya lo regularicé",
  "metaErrors.fixAt": "Regularizar en Meta Business",
  "metaErrors.bannerTitle": "Problema en la cuenta de WhatsApp Oficial",
  "metaErrors.bannerDismiss": "Descartar aviso de problema en la cuenta",
  "metaErrors.badge.131042": "Pago pendiente en Meta",
  "metaErrors.badge.131031": "Cuenta restringida por Meta",
  "metaErrors.badge.131045": "Número no registrado",
  "metaErrors.badge.133010": "Número no registrado",
  "metaErrors.badge.368": "Cuenta restringida por Meta",
  "metaErrors.badge.130497": "Envío restringido por país",
  "metaErrors.badge.134011": "Términos de pago pendientes",
  "metaErrors.badge.190": "Acceso a Meta vencido",
  "metaErrors.badge.default": "Problema en la cuenta",
  "metaErrors.accountToast": "Problema en la cuenta de WhatsApp: {{titulo}}",
  "metaErrors.composerWarning": "Problema en la cuenta de esta conexión: {{titulo}}. Aún puede enviar, pero los mensajes pueden no entregarse.",
  "metaErrors.failureLine": "No entregado: {{titulo}}.",
  "metaErrors.131042.title": "La cuenta de WhatsApp Business tiene un pago pendiente en Meta",
  "metaErrors.131042.action": "Regularícelo en Meta Business para volver a enviar",
  "metaErrors.131031.title": "Meta restringió o bloqueó la cuenta de WhatsApp Business",
  "metaErrors.131031.action": "Abra el Administrador de Negocios de Meta y siga las instrucciones de verificación",
  "metaErrors.131045.title": "El número de teléfono no está registrado en la API oficial",
  "metaErrors.131045.action": "Vuelva a registrar el número en la conexión de WhatsApp Oficial",
  "metaErrors.133010.title": "El número de teléfono no está registrado en la API oficial",
  "metaErrors.133010.action": "Vuelva a registrar el número en la conexión de WhatsApp Oficial",
  "metaErrors.368.title": "Meta restringió la cuenta por infringir sus políticas",
  "metaErrors.368.action": "Revise los detalles en el Administrador de Negocios de Meta y solicite una revisión",
  "metaErrors.130497.title": "La cuenta tiene restricciones para enviar a contactos de algunos países",
  "metaErrors.130497.action": "Envíe solo a contactos de países permitidos o hable con Meta",
  "metaErrors.134011.title": "Hay términos de pago de Meta pendientes de aceptar",
  "metaErrors.134011.action": "Acepte los términos de pago en Meta Business para volver a enviar",
  "metaErrors.190.title": "El acceso de la conexión a Meta expiró o no es válido",
  "metaErrors.190.action": "Reconecte WhatsApp Oficial en Conexiones para generar un nuevo acceso",
  "metaErrors.131047.title": "Pasaron más de 24 horas desde la última respuesta del cliente",
  "metaErrors.131047.action": "Envíe una plantilla aprobada para reabrir la conversación",
  "metaErrors.131026.title": "No se pudo entregar el mensaje: el contacto puede no tener WhatsApp, usar una versión antigua de la app o no haber aceptado los términos de WhatsApp",
  "metaErrors.131026.action": "Confirme el número con el contacto y pídale que actualice WhatsApp",
  "metaErrors.131050.title": "El contacto decidió no recibir mensajes de marketing",
  "metaErrors.131050.action": "No envíe marketing a este contacto; los mensajes de atención siguen permitidos",
  "metaErrors.130403.title": "El contacto bloqueó el número de su empresa",
  "metaErrors.130403.action": "No es posible enviar a este contacto hasta que lo desbloquee",
  "metaErrors.131049.title": "Meta limitó los mensajes de marketing para este contacto",
  "metaErrors.131049.action": "Inténtelo más tarde o envíe un mensaje no promocional",
  "metaErrors.131021.title": "El mensaje se envió al propio número de la empresa",
  "metaErrors.131021.action": "Indique el número del cliente como destinatario",
  "metaErrors.132001.title": "La plantilla no existe o no está aprobada para este idioma",
  "metaErrors.132001.action": "Revise el nombre y el idioma de la plantilla y que esté aprobada en Meta",
  "metaErrors.132015.title": "La plantilla está pausada por baja calidad",
  "metaErrors.132015.action": "Edite la plantilla en Meta o use otra aprobada",
  "metaErrors.132016.title": "La plantilla fue desactivada por baja calidad",
  "metaErrors.132016.action": "Cree una plantilla nueva y envíela para aprobación",
  "metaErrors.category.conta.title": "Meta rechazó el envío por un problema en la cuenta o la conexión",
  "metaErrors.category.conta.action": "Inténtelo de nuevo en unos minutos; si persiste, revise la conexión y la cuenta en Meta Business",
  "metaErrors.category.contato.title": "No se pudo entregar el mensaje a este contacto",
  "metaErrors.category.contato.action": "Revise el número y si el contacto puede recibir este mensaje",
  "metaErrors.category.janela.title": "La ventana de 24 horas de la conversación está cerrada",
  "metaErrors.category.janela.action": "Envíe una plantilla aprobada para reabrir la conversación",
  "metaErrors.category.template.title": "Meta rechazó el envío de la plantilla",
  "metaErrors.category.template.action": "Revise las variables y el estado de la plantilla en Meta",
  "metaErrors.category.limite.title": "Meta limitó los envíos por volumen o calidad",
  "metaErrors.category.limite.action": "Espere un poco y reduzca el ritmo de los envíos",
  "metaErrors.category.midia.title": "Meta no aceptó el archivo o el tipo de medio enviado",
  "metaErrors.category.midia.action": "Envíe un archivo en un formato y tamaño aceptados por WhatsApp",
  "metaErrors.unknown.title": "Meta no entregó el mensaje por un motivo no catalogado",
  "metaErrors.unknown.action": "Vea el texto original de Meta en los detalles técnicos",
  "backendErrors.ERR_PROMPT_WHATSAPP_REQUIRED": "Elige la conexión del agente.",
  "backendErrors.ERR_PROMPT_QUEUE_OR_PREQUEUE_REQUIRED": "Elige al menos una cola o marca “Atender también antes de la distribución”.",
  "backendErrors.ERR_PROMPT_QUEUE_NOT_IN_WHATSAPP": "Una de las colas elegidas no pertenece a esta conexión. Quítala y guarda de nuevo.",
  "backendErrors.ERR_PROMPT_QUEUE_CONFLICT": "Una de las colas ya tiene otro agente en esta conexión. Cada cola tiene como máximo un agente por conexión.",
  "backendErrors.ERR_PROMPT_PREQUEUE_CONFLICT": "Otro agente ya atiende antes de la distribución en esta conexión. Desmarca la opción o cambia el otro agente.",
  "campaigns.smsEstimate.landlineSkipped": "{{count}} contacto fijo se omitirá en el SMS (no recibe SMS y no consume crédito).",
  "campaigns.smsEstimate.landlineSkipped_plural": "{{count}} contactos fijos se omitirán en el SMS (no reciben SMS y no consumen crédito).",
  "contactListItems.numberType.landline": "Fijo",
  "contactListItems.numberType.landlineHint": "Teléfono fijo: se omite en campañas de SMS, sigue en las de WhatsApp.",
};
